module.exports = __webpack_public_path__ + "static/gingko-app-817f6355ffd86de2ea619a34dc4eab0c.png";